import React from 'react';
import './AssignmentHistoryTimeline.css';

const AssignmentHistoryTimeline = ({ history, title = 'Atama Geçmişi' }) => {
  if (!history || history.length === 0) {
    return (
      <div className="assignment-history-empty">
        <i className="fas fa-history"></i>
        <p>Henüz atama geçmişi bulunmamaktadır</p>
      </div>
    );
  }

  const getEventIcon = (atamaTipi, durum) => {
    if (durum === 'İptal Edildi' || durum === 'İptal') {
      return 'fa-times-circle';
    }
    
    switch (atamaTipi) {
      case 'Teknik Servis':
        return 'fa-building';
      case 'Teknisyen':
        return 'fa-user';
      case 'Operasyon':
        return 'fa-wrench';
      case 'Parça':
        return 'fa-cog';
      default:
        return 'fa-info-circle';
    }
  };

  const getEventColor = (durum) => {
    if (durum === 'İptal Edildi' || durum === 'İptal') {
      return '#ef4444';
    }
    if (durum === 'Atandı') {
      return '#10b981';
    }
    return '#6b7280';
  };

  const formatDate = (dateString) => {
    if (!dateString) return '---';
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    } catch (e) {
      return dateString;
    }
  };

  // Tarihe göre sıralama (en yeni en üstte)
  const sortedHistory = [...history].sort((a, b) => {
    const dateA = new Date(a.tarih || 0);
    const dateB = new Date(b.tarih || 0);
    return dateB - dateA; // Descending
  });

  return (
    <div className="assignment-history-timeline">
      <div className="timeline-header">
        <i className="fas fa-history"></i>
        <h3>{title}</h3>
        <span className="timeline-count">{sortedHistory.length} kayıt</span>
      </div>

      <div className="timeline-content">
        {sortedHistory.map((item, index) => {
          const eventColor = getEventColor(item.durum);
          const eventIcon = getEventIcon(item.atamaTipi, item.durum);
          const isCancel = item.durum === 'İptal Edildi' || item.durum === 'İptal';

          return (
            <div key={index} className="timeline-item">
              <div className="timeline-marker" style={{ borderColor: eventColor }}>
                <div className="timeline-icon" style={{ backgroundColor: eventColor }}>
                  <i className={`fas ${eventIcon}`}></i>
                </div>
              </div>

              <div className="timeline-card" style={{ borderLeftColor: eventColor }}>
                <div className="timeline-card-header">
                  <div className="timeline-card-title">
                    <span className="timeline-badge" style={{ backgroundColor: eventColor }}>
                      {item.atamaTipi}
                    </span>
                    <span className={`timeline-status ${isCancel ? 'cancel' : 'assign'}`}>
                      {item.durum}
                    </span>
                  </div>
                  <div className="timeline-date">
                    <i className="fas fa-clock"></i>
                    {formatDate(item.tarih)}
                  </div>
                </div>

                <div className="timeline-card-body">
                  {/* Atanan bilgisi */}
                  {item.atananAdi && (
                    <div className="timeline-info-row">
                      <i className="fas fa-user"></i>
                      <div className="timeline-info-content">
                        <span className="timeline-label">
                          {isCancel ? 'İptal Edilen' : 'Atanan'}:
                        </span>
                        <span className="timeline-value">{item.atananAdi}</span>
                      </div>
                    </div>
                  )}

                  {/* Atama yapan - hem yapanKisi objesi hem de atamaYapan string'ini destekle */}
                  {(item.yapanKisi || item.atamaYapan) && (
                    <div className="timeline-info-row">
                      <i className="fas fa-user-check"></i>
                      <div className="timeline-info-content">
                        <span className="timeline-label">
                          {isCancel ? 'İptal Eden' : 'Atama Yapan'}:
                        </span>
                        <span className="timeline-value">
                          {item.yapanKisi 
                            ? `${item.yapanKisi.ad || ''} ${item.yapanKisi.soyad || ''}`.trim() || item.yapanKisi.kullaniciAdi || 'Bilinmiyor'
                            : item.atamaYapan}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Gerekçe */}
                  {item.gerekce && (
                    <div className="timeline-info-row">
                      <i className="fas fa-comment-alt"></i>
                      <div className="timeline-info-content">
                        <span className="timeline-label">Gerekçe:</span>
                        <span className="timeline-value">{item.gerekce}</span>
                      </div>
                    </div>
                  )}

                  {/* Miktar (Parça için) */}
                  {item.miktar && (
                    <div className="timeline-info-row">
                      <i className="fas fa-sort-amount-up"></i>
                      <div className="timeline-info-content">
                        <span className="timeline-label">Miktar:</span>
                        <span className="timeline-value">{item.miktar}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AssignmentHistoryTimeline;
